import React, { useState } from "react";
import { Modal, ModalFooter, Button, Icon, TextArea, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useMutation } from "react-query";
import css from "../title/EntityRow.module.css";
/**
 * Confirmation dialog with an optional free-text note for a decision on a co-edition request
 * (the co-publisher's refusal, the agency confirming the consent on its behalf, the agency's
 * rejection of a request still awaiting the co-publisher).
 */
export var CoEditionDecisionModal = function (_a) {
    var titleId = _a.titleId, fieldLabelId = _a.fieldLabelId, submitLabelId = _a.submitLabelId, errorMessageId = _a.errorMessageId, onSubmit = _a.onSubmit, onClose = _a.onClose, onDone = _a.onDone, onError = _a.onError;
    var formatMessage = useIntl().formatMessage;
    var _b = useState(""), note = _b[0], setNote = _b[1];
    var mutation = useMutation(function () { return onSubmit(note.trim() || undefined); }, {
        onSuccess: function () { return onDone(); },
        onError: function () { return onError(formatMessage({ id: errorMessageId })); },
    });
    var footer = (React.createElement(ModalFooter, null,
        React.createElement(Button, { buttonStyle: "primary", disabled: mutation.isLoading, onClick: function () { return mutation.mutate(); } }, mutation.isLoading ? (React.createElement(React.Fragment, null,
            React.createElement(Icon, { icon: "spinner-ellipsis", size: "small" }),
            React.createElement(FormattedMessage, { id: "ui-br-agency.button.saving" }))) : (React.createElement(FormattedMessage, { id: submitLabelId }))),
        React.createElement(Button, { onClick: onClose, disabled: mutation.isLoading },
            React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" }))));
    return (React.createElement(Modal, { open: true, dismissible: true, onClose: onClose, size: "small", label: formatMessage({ id: titleId }), footer: footer },
        React.createElement("div", { className: css.assignBody },
            React.createElement(TextArea, { label: formatMessage({ id: fieldLabelId }), value: note, onChange: function (event) {
                    return setNote(event.target.value);
                } }))));
};
